import React from 'react';
import ReactMinimalPieChart from 'react-minimal-pie-chart';

export default class Chart extends React.Component {

	render() {
		return (
			<React.Fragment>
				<ReactMinimalPieChart
					animate={true}
					animationDuration={500}
					animationEasing='ease-out'
					//label={({ data, dataIndex }) => data[dataIndex].percentage + '%'}
					label={({ data, dataIndex }) => this.props.data[0].value + '%'}
					labelPosition={0}
					labelStyle={{
						fill: '#121212',
						fontSize: '12px',
						fontWeight: 'bold'
					}}
					data={this.props.data}
					lineWidth={25}
					totalValue={100}
					startAngle={180}
					background="#e5e5e5"
					viewBoxSize={[70, 70]}
				/>
			</React.Fragment>
		);
	}

}
